/**
 * Quantos itens (na ordem dada) cabem lado a lado dentro de `containerWidth`, com `gap`
 * entre eles — sem cortar nenhum no meio.
 *
 * Primeiro tenta caber tudo sem reservar espaço pro botão "Ver mais": só reserva (e
 * recalcula) quando de fato não cabe tudo, pra não desperdiçar espaço à toa nas larguras em
 * que os itens já cabem sozinhos.
 */
export function computeVisibleFilterCount(
  itemWidths: number[],
  containerWidth: number,
  gap: number,
  moreButtonWidth: number,
): number {
  const countThatFits = (limit: number) => {
    let used = 0;
    let count = 0;
    for (const width of itemWidths) {
      const next = used + (count > 0 ? gap : 0) + width;
      if (next > limit) break;
      used = next;
      count++;
    }
    return count;
  };

  if (countThatFits(containerWidth) === itemWidths.length) {
    return itemWidths.length;
  }
  return countThatFits(containerWidth - moreButtonWidth - gap);
}
